import { useContext } from 'react';
import { TextCodes } from '@api/types/translation/TextCodes';
import { PageList, ProductDetailsContext, ProductSection } from '@components';
import { t } from '@translations';

export const ProductPages = () => {
  const { product = {}, sections, onSectionEnter } = useContext(ProductDetailsContext);
  if (!sections?.related) {
    return null;
  }

  const mappedPages = product.pages?.map((x) => x.expanded || {}) || [];
  return (
    <ProductSection
      sectionId='related'
      title={t(TextCodes.Product.Details.RelatedMaterials)}
      onSectionEnter={onSectionEnter}
    >
      <PageList blocks={mappedPages} />
    </ProductSection>
  );
};
